/**
 * Created by pierremarsot on 24/07/2017.
 */
import {postApi} from '../tools/api';
import {setLocalStorage, deleteLocalStorage, ID_TOKEN, TYPE_COMPTE} from '../tools/localStorage';
import {sendMessageError} from './toast';

const validator = require("email-validator");

export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGIN_ERROR = 'LOGIN_ERROR';

export const LOGOUT_SUCCESS = 'LOGOUT_SUCCESS';
export const LOGOUT_ERROR = 'LOGOUT_ERROR';

function loginSuccess(payload) {
  return {
    type: LOGIN_SUCCESS,
    token: payload.token,
      type_compte: payload.type_compte,
  };
}

function loginError() {
  return {
    type: LOGIN_ERROR,
  };
}

export function login(email, password) {
  return dispatch => {
    if (!email || email.length === 0) {
      dispatch(sendMessageError("Vous devez spécifier un email"));
      return dispatch(loginError());
    }

    if(!validator.validate(email)){
      dispatch(sendMessageError("Votre email n'est pas valide"));
      return dispatch(loginError());
    }

    if (!password || password.length === 0) {
      dispatch(sendMessageError("Vous devez spécifier un mot de passe"));
      return dispatch(loginError());
    }

    postApi("/login/backend", {
      email: email,
      password: password
    })
      .then((response) => {
        if (response && response.token && response.type_compte) {
          if(!setLocalStorage(ID_TOKEN, response.token) || !setLocalStorage(TYPE_COMPTE, response.type_compte)){
              dispatch(sendMessageError("Erreur inconnue lors de la connexion"));
              return dispatch(loginError());
          } else {
              return dispatch(loginSuccess(response));
          }
        }

        dispatch(sendMessageError("Erreur inconnue lors de la connexion"));
        return dispatch(loginError());
      })
      .catch((response) => {
        if (response && response.error) {
          dispatch(sendMessageError(response.error));
        } else {
          dispatch(sendMessageError("Erreur inconnue lors de la connexion"));
        }

        return dispatch(loginError());
      });
  };
}

function logoutSuccess() {
  return {
    type: LOGOUT_SUCCESS,
  };
}

function logoutError() {
  return {
    type: LOGOUT_ERROR,
  };
}

export function logout() {
  return dispatch => {
    deleteLocalStorage(ID_TOKEN);
      deleteLocalStorage(TYPE_COMPTE);
    return dispatch(logoutSuccess());
  };
}


// WEBPACK FOOTER //
// ./src/actions/auth.js